<template>
	<div>
		<el-select
			size="mini"
			v-model="myValue"
			clearable
			value-key="index"
			:placeholder="'是否'+fieldName"
		>
			<el-option label="全部" value="-1"></el-option>
			<el-option label="是" value="1"></el-option>
			<el-option label="否" value="0"></el-option>
		</el-select>
	</div>
</template>
<script>
export default {
	data() {
		return {};
	},
	props: {
		field: {
			type: String,
			default: ""
		},
		fieldName: {
			type: String,
			default: ""
		},
		value: {
			type: [Number, String],
			default: null
		}
	},
	computed: {
		myValue: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				if (newValue == -1) {
					this.$emit("input", null);
					this.$emit("change", null);
				} else {
					this.$emit("input", newValue);
					this.$emit("change", newValue);
				}
			}
		}
	},
	created() {},
	mounted() {},
	methods: {},
	watch: {},
	components: {}
};
</script>
<style lang="scss" scoped>
</style>
